module.exports = function getResource(label, vars = []) {
    const resources = {
        shipToFedex: 'Expédition à un lieu de ramassage FedEx',
        selectLocationNearYou: 'Sélectionner un emplacement près de chez vous',
        orShipToFedexLocation: 'Ou expédier à un lieu de ramassage FedEx près de chez vous',
        accessPointInfoTitle: 'Expédier à un lieu de ramassage FedEx',
        changeAlternateLocation: 'Changer l’autre lieu de ramassage'
    };

    return resources[label];
};
